import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { homeFor } from "@/lib/format";
import { Loading } from "@/components/common";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Athletes from "@/pages/Athletes";
import AthleteDetail from "@/pages/AthleteDetail";
import Licenses from "@/pages/Licenses";
import LicenseDetail from "@/pages/LicenseDetail";
import Requests from "@/pages/Requests";
import Events from "@/pages/Events";
import Scanner from "@/pages/Scanner";
import Participations from "@/pages/Participations";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import MyLicense from "@/pages/MyLicense";
import PublicVerify from "@/pages/PublicVerify";
import AuthCallback from "@/pages/AuthCallback";
import SetPassword from "@/pages/SetPassword";
import ForgotPassword from "@/pages/ForgotPassword";
import MyRaces from "@/pages/MyRaces";
import PublicHome from "@/pages/PublicHome";
import PublicCheck from "@/pages/PublicCheck";

function Protected({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="px-8"><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return <div className="px-8"><Loading /></div>;
  return <Navigate to={user ? homeFor(user.role) : "/login"} replace />;
}

const A = ["admin"], AS = ["admin", "sector_manager"], ASO = ["admin", "sector_manager", "organizer"];

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/v/:token" element={<PublicVerify />} />
            <Route path="/verifica" element={<PublicCheck />} />
            <Route path="/imposta-password" element={<SetPassword />} />
            <Route path="/password-dimenticata" element={<ForgotPassword />} />
            <Route path="/" element={<PublicHome />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/dashboard" element={<Protected roles={AS}><Dashboard /></Protected>} />
              <Route path="/atleti" element={<Protected roles={AS}><Athletes /></Protected>} />
              <Route path="/atleti/:id" element={<Protected roles={AS}><AthleteDetail /></Protected>} />
              <Route path="/licenze" element={<Protected roles={AS}><Licenses /></Protected>} />
              <Route path="/licenze/:id" element={<Protected roles={[...AS, "athlete"]}><LicenseDetail /></Protected>} />
              <Route path="/richieste" element={<Protected roles={AS}><Requests /></Protected>} />
              <Route path="/manifestazioni" element={<Protected roles={ASO}><Events /></Protected>} />
              <Route path="/scanner" element={<Protected roles={["admin", "organizer"]}><Scanner /></Protected>} />
              <Route path="/partecipazioni" element={<Protected roles={ASO}><Participations /></Protected>} />
              <Route path="/report" element={<Protected roles={ASO}><Reports /></Protected>} />
              <Route path="/utenti" element={<Protected roles={A}><Users /></Protected>} />
              <Route path="/impostazioni" element={<Protected roles={A}><Settings /></Protected>} />
              <Route path="/mia-licenza" element={<Protected roles={["athlete"]}><MyLicense /></Protected>} />
              <Route path="/mie-gare" element={<Protected roles={["athlete"]}><MyRaces /></Protected>} />
            </Route>
            <Route path="*" element={<Home />} />
          </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
